import { Link } from "react-router-dom";
import QueryBoundary from "../../components/ui/QueryBoundary";
import useApiQuery from "../../hooks/useApiQuery";
import useScrollTop from "../../hooks/useScrollTop";
import endpoints from "../../api/endpoints";
import CategoryRow from "./CategoryRow";
import HeroCarousel from "./HeroCarousel";

const HomePage = () => {
  useScrollTop();

  // One banners request feeds both the hero and the between-row promos.
  // The old page fetched this endpoint twice: once here, once inside <Main>.
  const banners = useApiQuery(endpoints.homeBanners());
  const categories = useApiQuery(endpoints.homeCategories());

  const headBanners = banners.data?.head_banners ?? [];
  const otherBanners = banners.data?.other_banners ?? [];

  return (
    <>
      <HeroCarousel banners={headBanners} />

      <div className="mb-[8rem] mt-[4rem]">
        <QueryBoundary
          {...categories}
          isEmpty={(data) => data.length === 0}
          emptyMessage="هنوز دسته‌بندی‌ای منتشر نشده است."
        >
          {(data) =>
            data.map((category, index) => (
              <div key={category.id}>
                <CategoryRow category={category} />
                {otherBanners[index] && (
                  <Link to={otherBanners[index].url ?? "#"}>
                    <div className="mb-10 mt-4 w-full md:mt-6">
                      <img
                        src={otherBanners[index].image}
                        alt={otherBanners[index].title}
                        className="mx-auto h-full w-[95%] object-cover"
                        loading="lazy"
                      />
                    </div>
                  </Link>
                )}
              </div>
            ))
          }
        </QueryBoundary>
      </div>
    </>
  );
};

export default HomePage;
